<template>
  <div class="top-bar d-flex justify-space-between align-center">
    <div class="d-flex align-center">
      <v-img v-if="!isNatixisAccount && !signingFromSubdomain"
             src="@/assets/img/closd_logo.svg"
             width="130"
      ></v-img>
      <v-img v-if="isNatixisAccount && !signingFromSubdomain"
             src="@/assets/img/logo_xNatixis.png"
             width="111"
             height="63"
      ></v-img>
    </div>

    <ClosdLangSelector v-if="withLangSelector" />
  </div>
</template>

<script>
import ClosdLangSelector from '@/common/ClosdLangSelector.vue'
import { navigatingOnAvailableSubdomain } from '@/common/utils/url'

export default {
  name: 'LoginTopbar',
  components: { ClosdLangSelector },
  props: {
    withLangSelector: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      isNatixisAccount: false,
      signingFromSubdomain: false,
    }
  },
  mounted () {
    this.isNatixisAccount = import.meta.env.VUE_APP_ENABLE_NATIXIS_PASSWORD === 'true'
    this.signingFromSubdomain = navigatingOnAvailableSubdomain()
  },
}
</script>

<style scoped lang="scss">
.top-bar {
  height: 65px;
}
</style>
